import React from 'react'

function IOT_program_details() {
  return (
    <div>
      {/* ---------------------Mobile view-------------------- */}
      <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>The Sparkling future in IOT</h1>
                    <p className='py-2'>Dive into the world of robotics! Unleash your potential, enroll now, and pave the way to a bright future where innovation and automation collide for unparalleled opportunities</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>With our extensive course, take a revolutionary step into the world of robotics. Explore the laws, types, and components of robot design as you delve into its complexities. Master the ATmega 328p microcontroller to integrate sensors and actuators. Learn how to program Arduino devices for stepper, servo, and DC motors. Discover how to communicate via Bluetooth, SPI, and I2C, and become fully immersed in the potential of ROS for sophisticated robotic movements. Finish it off with a practical project that demonstrates your acquired knowledge. Kindle your enthusiasm for innovation and robotics!</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Internet of Things</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
      </div>

      {/* ---------------------------Desktop View----------------- */}
      <div className='d-none d-md-block'>
        <div className='container'>
          <div className='row'>
              <div className='col-md-8 detail_1stcomp_img'>
                  <div className='pt-3 Program_details_1stcomp_text'>
                      <h1 className='display-6'>The Sparkling future in IOT</h1>
                      <p className='py-4'>Dive into the world of robotics! Unleash your potential, enroll now, and pave the way to a bright future where innovation and automation collide for unparalleled opportunities.</p>
                  </div>
                  <div className='mt-3 Program_details_1stcomp_text'>
                      <h1 className='display-3'>Overview</h1>
                      <p className='py-4'>With our extensive course, take a revolutionary step into the world of robotics. Explore the laws, types, and components of robot design as you delve into its complexities. Master the ATmega 328p microcontroller to integrate sensors and actuators. Learn how to program Arduino devices for stepper, servo, and DC motors. Discover how to communicate via Bluetooth, SPI, and I2C, and become fully immersed in the potential of ROS for sophisticated robotic movements. Finish it off with a practical project that demonstrates your acquired knowledge. Kindle your enthusiasm for innovation and robotics!</p>
                  </div>
              </div>
              <div className='col-md-4'>
                  <div>
                  <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                  <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Internet of Things</h1>
                    <div className='Details_text '>
                      <ul className='pt-4'>
                        <li>Live conversations with industry professionals</li>
                        <li className='py-3'>Project support and Guidance</li>
                        <li>Access to Specialized Course Materials</li>
                        <li className='py-3'>25+ Hours of Learning</li>
                        <li>Certificates from reputable MNC's around the world</li>
                      </ul>
                    </div>
                    <div className='text-center'>
                    {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                    </div>
                  </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IOT_program_details
